<template>
    <input
        :type="type"
        :id="id"
        :name="name"
        class="input"
        :class="{TA:isTestAchat, unit: unit ? `unit ${unit}` : ''}"
        v-bind:value="value" 
        v-on:blur="$emit('blur')"
        v-on:input="update($event.target.value)"
        ref="input"
        />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        type: {
            type: String
        },
        id: {
            type: String
        },
        name: {
            type: String
        },
        unit: {
            type: String
        },
        value: [Number, String]
    },
    computed: {
        ...mapGetters("common", ["isTestAchat"])
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    },
    mounted(){
        if(this.isTestAchat) this.$refs.input.style.fontFamily = "Lato";
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/InputField.vue